<template>
  <div class="header" id="header" refs="header" :class="{ active: isActive }">
    <div class="header__icon" @click="openMenu">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <router-link to="/" tag="div" class="header__logo">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 411.5 73">
        <text class="text" transform="translate(23.8 44.5)" font-size="25" fill="#fff" font-family="Raleway-Regular, Raleway">Giguè
          <tspan x="68.3" y="0" letter-spacing="-0.03em">r</tspan>
          <tspan x="76.4" y="0">e, </tspan>
          <tspan x="103.1" y="0" letter-spacing="-0.02em">L</tspan>
          <tspan x="117.2" y="0" letter-spacing="-0.01em">é</tspan>
          <tspan x="131.5" y="0" letter-spacing="-0.02em">v</tspan>
          <tspan x="144.4" y="0">eillé,</tspan>
          <tspan x="198.4" y="0" letter-spacing="-0.03em"> </tspan>
          <tspan x="204.1" y="0" letter-spacing="-0.11em">T</tspan>
          <tspan x="216.6" y="0">ria - </tspan>
          <tspan x="267.7" y="0" letter-spacing="-0.01em">No</tspan>
          <tspan x="301.5" y="0">tai</tspan>
          <tspan x="329" y="0" letter-spacing="-0.03em">r</tspan>
          <tspan x="337.1" y="0">es</tspan>
        </text>
        <polyline class="lines lines1" points="0.8 31.5 0.8 0.8 31.5 0.8" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="1.5"/>
        <polyline class="lines lines2" points="410.8 41.5 410.8 72.3 380 72.3" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="1.5"/>
      </svg>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'navigation',
  data() {
    return {
    }
  },
  props: {
    isActive: Boolean
  },
  methods: {
    openMenu() {
      this.isActive = true;
      this.$emit('reactiveIsActive', this.isActive);
    }
  }
}


</script>
